import React, { memo, Suspense, useEffect, useState } from "react";
import CSS from "csstype";
import { Wrapper } from "./style";
import Loader from "../Loader/Loader";
import tablesSortWrapper from "../../utils/sortWorkspaces";
import { IPage } from "store/reducers/QuotesPageReducer";
import { ICurrentTab, IGrid } from "store/reducers/TabsSlice";


const TableSingleRow = React.lazy(() => import("./TableSingleRow"));
const TableOneTopOneBottom = React.lazy(
    () => import("./TwoRowOneColumnTables"),
);
const TableTopOneBottomTwo = React.lazy(() => import("./TableTopOneBottomTwo"));
const TableTopTwoBottomTwo = React.lazy(() => import("./TableTopTwoBottomTwo"));
const TableOne = React.lazy(() => import("./TableOne"));

const loaderStyle: CSS.Properties = {
    position: "absolute",
    inset: 0,
    margin: "0 auto",
};

interface ITableProps {
    openAddTickers: any;
    activePage: IPage;
    workspaces: any[];
    currentTab: ICurrentTab;
    grid: IGrid;
    order: number[];
}

const Tables = ({
    openAddTickers,
    activePage,
    workspaces,
    grid,
    order,
    currentTab,
}: ITableProps) => {
    const { id } = activePage;
    const tables = workspaces;
    const [sections, setSections] = useState<any>(undefined);

    useEffect(() => {
        if (order && order?.length) {
            const sorted = tablesSortWrapper([...order], order);
            setSections(sorted);
        }
    }, [order]);

    return (
        <Wrapper id={`quotes_page_wrapper`}>
            <Suspense fallback={<Loader style={loaderStyle} size="large" />}>
                {tables && tables.length > 0 && sections?.length && (
                    <>
                        {grid === "1-0" && (
                            <TableOne
                                currentTab={currentTab}
                                openAddTickers={openAddTickers}
                                tablesArr={tables}
                                activePageId={id}
                            />
                        )}
                        {grid === "2-0" && (
                            <TableSingleRow
                                activePageId={id}
                                openAddTickers={openAddTickers}
                                tablesArr={[...tables.slice(0, 2)]}
                                currentTab={currentTab}
                                sections={sections}
                            />
                        )}
                        {grid === "3-0" && (
                            <TableSingleRow
                                activePageId={id}
                                openAddTickers={openAddTickers}
                                tablesArr={[...tables.slice(0, 3)]}
                                currentTab={currentTab}
                                sections={sections.slice(0, 3)}
                            />
                        )}
                        {grid === "4-0" && (
                            <TableSingleRow
                                activePageId={id}
                                openAddTickers={openAddTickers}
                                currentTab={currentTab}
                                tablesArr={tables}
                                sections={sections}
                            />
                        )}
                        {grid === "1-1" && (
                            <TableOneTopOneBottom
                                activePageId={id}
                                openAddTickers={openAddTickers}
                                tablesArr={[...tables.slice(0, 2)]}
                                minHeight={500}
                                sections={sections}
                                currentTab={currentTab}
                            />
                        )}
                        {grid === "1-2" && (
                            <TableTopOneBottomTwo
                                activePageId={id}
                                openAddTickers={openAddTickers}
                                tablesArr={[...tables.slice(0, 3)]}
                                minHeight={500}
                                sections={sections}
                                currentTab={currentTab}
                            />
                        )}
                        {grid === "2-2" && (
                            <TableTopTwoBottomTwo
                                activePageId={id}
                                openAddTickers={openAddTickers}
                                tablesArr={tables}
                                currentTab={currentTab}
                                sections={sections}
                            />
                        )}
                    </>
                )}
            </Suspense>
        </Wrapper>
    );
};
/*
export default memo(Tables, (prevProps, nextProps) => {
    // const tab_check = deepEqual(prevProps.currentTab, nextProps.currentTab);
    const active_page_check = deepEqual(prevProps.activePage?.id, nextProps.activePage?.id);
    const workspaces_check = deepEqual(prevProps.workspaces, nextProps.workspaces);
    const grid_check = prevProps.grid === nextProps.grid;
    return (workspaces_check && grid_check && active_page_check);
});
*/

export default memo(Tables);
